import { useCallback, useState } from 'react';
import { getSavedLanguage, saveLanguage, translate } from '@/shared/i18n/cftsign';

/**
 * La langue du parcours de signature, et la fonction de traduction qui va avec.
 *
 * Le choix est gardé dans le navigateur plutôt que sur le compte : un poseur emprunte
 * parfois la tablette d'un collègue, et il ne doit pas avoir à modifier son profil pour
 * lire son écran dans sa langue. Le choix suit l'appareil, pas la personne.
 *
 * Usage :
 *   const { langue, changerLangue, t } = useLangue();
 *   <h1>{t('step1_title')}</h1>
 */
export default function useLangue() {
  const [langue, setLangue] = useState(getSavedLanguage);

  const changerLangue = useCallback((code) => {
    saveLanguage(code);
    setLangue(code);
  }, []);

  // `secours` sert quand une clé n'existe pas encore : on affiche le texte français
  // écrit sur place plutôt qu'un identifiant technique. Un poseur qui verrait
  // « lbl_civilite » serait plus perdu qu'avec un mot français qu'il ne comprend pas.
  const t = useCallback((cle, secours) => translate(langue, cle, secours), [langue]);

  return { langue, changerLangue, t };
}
